import { selectUiDefinition } from "../../../balancingSelectors/selectBalancingUiDefinitions";
import { IdMenuBalancing } from "../../../constants/IdMenuBalancing";
import { selectAllExistingBuildingInfo } from "../../../selectors/selectExistingBuildingInfo";
import { BuildingCategory } from "../../player-base/buildings/BuildingCategory";
export var selectBuildingDecorationsAvailable = function (state) {
    var type = BuildingCategory.Decorations;
    var buildingCategories = selectUiDefinition(IdMenuBalancing.Build).category;
    var buildingOfType = buildingCategories.find(function (buildingType) { return buildingType.id === type; });
    var buildingItem = buildingOfType.buildingItem;
    var buildingUsableIds = buildingItem
        ? buildingItem.map(function (building) { return building.buildingId; })
        : [];
    return selectAllExistingBuildingInfo(state).filter(function (building) { return buildingUsableIds.indexOf(building.proto.typeId) !== -1; });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/selectors/selectBuildingDecorationsAvailable.ts
// module id = 903
// module chunks = 3